import React, {Component} from 'react';
import BooleanIcon from '../buttons/BooleanIcon';
import DialogRow from './DialogRow';
import ReportJobDialogRow from './ReportJobDialogRow';
import {convertDate, getTodayOffsetHour} from '../shared/functions';
import {viewStyles} from '../shared/styles-view';
import Chip from 'material-ui/Chip';

const WorkerBlock = ({data, configData}) => {
    const category = data.worker_package;
    const report = data.worker_class;
    const reportObj = (configData[category] && configData[category].executors[report]) ? configData[category].executors[report] : {};
    return (
        <table>
            <tbody>
            <tr>
                <td>Category: </td>
                <td>{(category && configData[category]) ? configData[category].title : data.worker_package}</td>
            </tr>
            <tr>
                <td>Report: </td>
                <td>{(reportObj) ? reportObj.title : data.worker_class}</td>
            </tr>
            </tbody>
        </table>
    )
};

/**
 * Dialog component to display Report Job detailsF
 */
class ReportJobDetail extends Component {

    // Assemble Worker Args
    assembleWorkerArgs = (data, configData) => {
        let list = [];
        const category = data.worker_package;
        const reportName = data.worker_class;
        const report = (configData[category] && configData[category].executors[reportName]) ? configData[category].executors[reportName] : {};
        const params = (report && report.params) ? report.params : [];
        if (data.worker_args) {
            Object.entries(data.worker_args).forEach((entry, idx) => {
                let [key, value] = entry;
                const type = typeof value;
                const param = params.find(r => r.param === key);
                let include = false;
                if (key !== 'system' && value) {
                    if (
                        (type === 'object' && value.length > 0) ||
                        (type === 'string' && value !== '') ||
                        type === 'number'
                    ) {
                        include = true;
                    }
                }
                if (type === 'boolean' && value !== undefined) {
                    include = true;
                }
                if (include) {
                    list.push({
                        key: key,
                        label: (param) ? param.label : key,
                        tooltip: (param) ? param.tooltip : '',
                        value: (type === 'object') ? value : value.toString()
                    });
                }
            });
        }
        return list;
    };

    renderWorkerArgRows = (list) => {
        return (
            list.map((item) => <ReportJobDialogRow
                key={`arg-row-${item.key}`}
                label={item.label}
                tooltip={item.tooltip}
                children={(typeof item.value === 'object')
                    ? [...this.renderWorkerArgChips(item.key, item.value)]
                    : [...this.renderWorkerArgChips(item.key, [item.value])]}
                classes="worker-arg"
            />)
        );
    };

    renderWorkerArgChips = (key, list) => {
        return (
            list.map((item, idx) => <Chip
                    key={`arg-item-${key}=${idx}`}
                    label={item}
                    style={viewStyles.chip}>
                    {item}
                </Chip>
            )
        );
    };

    render() {
        const {
            configData,
            data
        } = this.props;

        const workerArgs = this.assembleWorkerArgs(data, configData);
        const offsetHour = getTodayOffsetHour();
        const createdAtStr = (data.created_at) ? convertDate(data.created_at, 'display', true, true, offsetHour, true) : '';
        const updatedAtStr = (data.updated_at) ? convertDate(data.updated_at, 'display', true, true, offsetHour, true) : '';

        return (
            <div className="reports-custom-table-container">
                {data.id &&
                    <DialogRow label="ID" value={data.id}/>
                }
                {data.name &&
                    <DialogRow label="Name" value={data.name}/>
                }
                {data.description &&
                    <DialogRow label="Description" value={data.description}/>
                }
                <DialogRow label="Complete" children={<BooleanIcon record={data.complete}/>} value={data.complete}/>
                {data.state_message &&
                    <DialogRow label="State Message" value={data.state_message}/>
                }
                {data.user &&
                    <DialogRow label="Submitted by" value={data.user}/>
                }
                {createdAtStr &&
                    <DialogRow label="Created" value={createdAtStr}/>
                }
                {updatedAtStr &&
                    <DialogRow label="Last Modified" value={updatedAtStr}/>
                }
                {data.worker_package && data.worker_class &&
                    <DialogRow label="Worker Details" children={<WorkerBlock data={data} configData={configData}/>}/>
                }
                {[...this.renderWorkerArgRows(workerArgs)]}
            </div>
        );
    }
}

export default ReportJobDetail;



// WEBPACK FOOTER //
// ./src/Fuse/components/ReportJobDetail.js